import axios from "axios";
export default class ApiService {
    static API_URL = "/api";

    static defaultGet = async (url, action) => {
        const response = await axios.get(`${this.API_URL}/${url}`);
        if (action && response) {
            action(response)
        }
        return response;
    }

    static defaultPost = async (url, formData, action) => {
        const response = await axios.post(`${this.API_URL}/${url}`, formData);
        if (action && response) {
            action(response)
        }
        return response;
    }

    static get = this.defaultGet

    static post = this.defaultPost

    static absoluteGet = async (absoluteUrl, action) => {
        const response = await axios.get(`${absoluteUrl}`, { withCredentials: true});
        if (action && response) {
            action(response)
        }
        return response;
    }
}